interface Param {
  name: string;
  value: string;
}

class UrlBuilder {
  base: string = '';
  parameters: any = [];

  addParameter(name: string, value: string | number | boolean) {
    if (value !== undefined) {
      this.parameters.push({ name, value });
    }
  }

  toString = () => {
    if (this.parameters.length > 0) {
      return `${this.base}?${this.parameters
        .map(({ name, value }: Param) => `${name}=${encodeURIComponent(value)}`)
        .join('&')}`;
    } else {
      return this.base;
    }
  };

  constructor(baseUrl: string) {
    this.base = baseUrl;
    this.parameters = [];
  }
}

const createUrlBuilder = (baseUrl: string) => new UrlBuilder(baseUrl);

export default createUrlBuilder;
